module.exports = __webpack_public_path__ + "media/svg/gb-eng-c15527cb.svg";